<template>
  <div class="language-switcher">
    <!-- 触发图标 -->
    <div
      class="trigger-icon nav-action-icon-button d-flex align-items-center"
      @click="showModal = true"
    >
      <img
        class="nav-action-icon"
        src="@/assets/home/nav-language.png"
        alt=""
      />
      <!-- <span style="margin-left: 4px; font-size: 14px">{{
        sleLang === "zh-CN" ? "简体中文" : "English"
      }}</span> -->
    </div>

    <!-- 弹窗 -->
    <b-modal
      v-model="showModal"
      :title="$t('区域偏好')"
      centered
      hide-footer
      size="md"
    >
      <div class="language-modal-content">
        <!-- 语言选择 -->
        <div class="section">
          <h6 class="section-title">{{ $t("语言") }}</h6>
          <div class="options-row">
            <div
              class="option-item"
              :class="{ active: isLang === 'zh-CN' }"
              @click="selectLanguage('zh-CN')"
            >
              简体中文
            </div>
            <div
              class="option-item"
              :class="{ active: isLang === 'en' }"
              @click="selectLanguage('en')"
            >
              English
            </div>
          </div>
        </div>

        <!-- 货币选择 -->
        <div class="section">
          <h6 class="section-title">{{ $t("货币") }}</h6>
          <div class="options-row">
            <div
              class="option-item"
              :class="{ active: currency === 'USD' }"
              @click="selectCurrency('USD')"
            >
              USD
            </div>
            <div
              class="option-item"
              :class="{ active: currency === 'CNY' }"
              @click="selectCurrency('CNY')"
            >
              CNY
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { updateUserInfoApi } from "@/api/personalCenter/index";
import { getUserInfoApi } from "@/api/modules/home";
export default {
  name: "LanguageSwitcher",
  data() {
    return {
      showModal: false,
      userInfo: null,
    };
  },
  computed: {
    isLang() {
      return this.$store.state.isLang;
    },
    currency() {
      return this.userInfo?.currencyPreference || this.$store.state.isCurrency;
    },
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      const userInfo = localStorage.getItem("userInfo");
      this.userInfo = userInfo ? JSON.parse(userInfo) : null;
      if (this.userInfo) {
        this.$store.commit("SET_ISCURRENCY", this.userInfo?.currencyPreference);
      }
    },
    selectLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("SET_LANG", lang);
      // 可以添加其他语言切换逻辑
      this.showModal = false;
      location.reload();
    },
    async selectCurrency(curr) {
      const data = {
        currencyPreference: curr,
      };
      if (this.userInfo) {
        await updateUserInfoApi(data);
        await this.getUser();
        this.$store.commit("SET_ISCURRENCY", curr);
        this.showModal = false;
        location.reload();
      } else {
        this.$store.commit("SET_ISCURRENCY", curr);
        this.showModal = false;
      }
    },
    async getUser() {
      const { code, data } = await getUserInfoApi();
      if (code !== 0) return;
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.userInfo = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.language-switcher {
  .trigger-icon {
    width: 24px;
    height: 24px;
    justify-content: center;
    cursor: pointer;
    color: #333;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.78;
    }
  }

  .nav-action-icon {
    display: block;
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
}

.language-modal-content {
  padding: 20px 0;

  .section {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 14px;
      color: #666;
      margin-bottom: 15px;
      font-weight: normal;
    }

    .options-row {
      display: flex;
      gap: 20px;

      .option-item {
        padding: 8px 20px;
        text-align: center;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        color: #666;
        font-size: 14px;

        &:hover {
          border-color: #4077f8;
          color: #4077f8;
        }

        &.active {
          border-color: #4077f8;
          color: #4077f8;
          background-color: rgba(64, 119, 248, 0.05);
          font-weight: 500;
        }
      }
    }
  }
}

::v-deep .modal-header {
  border-bottom: 1px solid #f0f0f0;
  padding: 15px 20px;

  .modal-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
}

::v-deep .modal-body {
  padding: 0 20px;
}
</style>
